import { Constants, WidgetNames } from '@finxone-platform/shared/sys-config-types';

export const downloadRangeNestedWidgets = {
  resetButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Reset changes button',
    attributes: {
      widgetProperties: {
        textContent: 'Reset changes',
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
        paddingBottom: 15,
        paddingTop: 15,
        color: 'var(--color-primary)',
        backGroundColor: 'var(--color-background)',
        isTextUnderline: true,
      },
    },
  },
};

export const enterEmailNestedWidgets = {
  reviewDetailsButton: {
    widgetConfigDisplayName: 'Send Link',
    name: WidgetNames.BUTTON,
    attributes: {
      widgetProperties: {
        textContent: 'Send Link',
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
        color: 'var(--color-background)',
        marginUnit: 'px',
        marginBottom: 25,
        paddingTop: 15,
        paddingBottom: 15,
        backGroundColor: 'var(--color-primary)',
      },
    },
  },
};
